import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Spin, Tag, Tooltip } from 'antd';
import clsx from 'clsx';
import { txt } from 'libs/i18n';
import tagStyles from '../TagContent/style.module.less';
const { CheckableTag } = Tag;
const TagCheckable = ({ tag, disabled, checked, onTagCheckChange, loadingTags, tagStyle, }) => {
    var _a, _b;
    const isTagLoading = (_a = loadingTags === null || loadingTags === void 0 ? void 0 : loadingTags.includes(tag.title)) !== null && _a !== void 0 ? _a : false;
    const areTagsLoading = ((_b = loadingTags === null || loadingTags === void 0 ? void 0 : loadingTags.length) !== null && _b !== void 0 ? _b : 0) > 0;
    const checkableTagClassName = useMemo(() => clsx((areTagsLoading && !isTagLoading) || disabled === true
        ? tagStyles.beeyTagDisabled
        : '', tagStyles.beeyTag), [areTagsLoading, isTagLoading, disabled]);
    const handleTagCheckChange = (checkedBool) => {
        if (!areTagsLoading && disabled !== true) {
            onTagCheckChange === null || onTagCheckChange === void 0 ? void 0 : onTagCheckChange(tag.title, checkedBool);
        }
    };
    return (_jsx(Tooltip, { title: disabled === true ? txt('readOnlyProject') : false, children: _jsxs(CheckableTag, { checked: checked !== null && checked !== void 0 ? checked : false, style: tagStyle, onChange: handleTagCheckChange, className: checkableTagClassName, children: [isTagLoading && _jsx(Spin, { size: "small" }), tag.title] }) }));
};
export default TagCheckable;
